module.exports = __webpack_public_path__ + "static/media/add-playlist-btn.de26e8db.svg";